/**
 * Vorgefertigte Umfrage-Strukturen (Templates) für den Drawflow-Editor.
 */

export const surveyTemplates = {
  "lead-qualifikation": {
    nodes: [
      {
        id: 1,
        name: "einfach",
        class: "einfach",
        pos_x: 60,
        pos_y: 120,
        data: {
          frage: "Was ist dein primäres Ziel?",
          answer1: "Neukunden gewinnen",
          answer2: "Prozesse automatisieren",
          answer3: "Kosten senken",
          answer4: "Bekanntheit & Reichweite steigern",
        },
      },
      {
        id: 2,
        name: "kontakt",
        class: "kontakt",
        pos_x: 520,
        pos_y: 120,
        data: {
          header: "Deine Kontaktdaten",
          titel: "Deine Kontaktdaten",
          description: "Fülle das Formular aus, um dein individuelles Angebot zu erhalten.",
          untertitel: "Fülle das Formular aus, um dein individuelles Angebot zu erhalten.",
          mail: "1",
          phone: "optional",
        },
      },
      {
        id: 3,
        name: "save",
        class: "save",
        pos_x: 980,
        pos_y: 120,
        data: {
          titel: "Vielen Dank!",
          text: "Deine Angaben wurden erfolgreich übermittelt.",
          autoreload: "none",
          autoReload: "none",
        },
      },
    ],
    connections: [
      [1, 2, "output_1", "input_1"],
      [2, 3, "output_1", "input_1"],
    ],
  },

  "kunden-feedback": {
    nodes: [
      {
        id: 1,
        name: "skala",
        class: "skala",
        pos_x: 60,
        pos_y: 120,
        data: {
          frage: "Wie zufrieden bist du mit unserem Service?",
          type: "star",
          count: "5",
        },
      },
      {
        id: 2,
        name: "freitext",
        class: "freitext",
        pos_x: 520,
        pos_y: 120,
        data: {
          frage: "Was können wir noch verbessern?",
          placeholder: "Gib hier dein Feedback ein...",
        },
      },
      {
        id: 3,
        name: "save",
        class: "save",
        pos_x: 980,
        pos_y: 120,
        data: {
          titel: "Danke für dein Feedback!",
          text: "Wir schätzen deine Meinung sehr.",
          autoreload: "false",
          autoReload: "false",
        },
      },
    ],
    connections: [
      [1, 2, "output_1", "input_1"],
      [2, 3, "output_1", "input_1"],
    ],
  },

  "positives-feedback": {
    nodes: [
      {
        id: 1,
        name: "skala",
        class: "skala",
        pos_x: 60,
        pos_y: 120,
        data: {
          frage: "Wie hat es dir bei uns gefallen?",
          type: "smiley5",
          skalaTyp: "smiley5",
        },
      },
      {
        id: 2,
        name: "save",
        class: "save",
        pos_x: 520,
        pos_y: 120,
        data: {
          titel: "Vielen Dank für deine Bewertung!",
          text: "Deine Bewertung wurde erfolgreich übermittelt.",
          autoreload: "true",
          autoReload: "true",
        },
      },
    ],
    connections: [[1, 2, "output_1", "input_1"]],
  },

  "termin-qualifikation": {
    nodes: [
      {
        id: 1,
        name: "mehrfach",
        class: "mehrfach",
        pos_x: 60,
        pos_y: 120,
        data: {
          frage: "Welche Bereiche interessieren dich?",
          answer1: "Beratung & Strategie",
          answer2: "Software & Automatisierung",
          answer3: "Marketing & Leadgenerierung",
          answer4: "Kundenservice & Support",
        },
      },
      {
        id: 2,
        name: "einfach",
        class: "einfach",
        pos_x: 520,
        pos_y: 120,
        data: {
          frage: "Wann planst du die Umsetzung?",
          answer1: "Sofort / Innerhalb von 30 Tagen",
          answer2: "In 1 bis 3 Monaten",
          answer3: "In 3 bis 6 Monaten",
          answer4: "Nur zur Orientierung / Information",
        },
      },
      {
        id: 3,
        name: "kontakt",
        class: "kontakt",
        pos_x: 980,
        pos_y: 120,
        data: {
          header: "Termin sichern",
          titel: "Termin sichern",
          description: "Trage deine Daten ein für ein kostenloses Erstgespräch.",
          untertitel: "Trage deine Daten ein für ein kostenloses Erstgespräch.",
          mail: "1",
          phone: "1",
        },
      },
      {
        id: 4,
        name: "save",
        class: "save",
        pos_x: 1440,
        pos_y: 120,
        data: {
          titel: "Terminanfrage gesendet",
          text: "Wir melden uns in Kürze bei dir!",
          autoreload: "none",
          autoReload: "none",
        },
      },
    ],
    connections: [
      [1, 2, "output_1", "input_1"],
      [2, 3, "output_1", "input_1"],
      [3, 4, "output_1", "input_1"],
    ],
  },

  "bewertungs-weiche": {
    nodes: [
      {
        id: 1,
        name: "skala",
        class: "skala",
        pos_x: 60,
        pos_y: 220,
        data: {
          frage: "Wie zufrieden bist du mit unserem Service?",
          type: "star",
          skalaTyp: "star",
          count: "5",
        },
      },
      {
        id: 2,
        name: "weiche",
        class: "weiche",
        pos_x: 520,
        pos_y: 220,
        data: {
          operator: "gte",
          value: "4",
        },
      },
      {
        id: 3,
        name: "link",
        class: "link",
        pos_x: 1020,
        pos_y: 100,
        data: {
          titel: "Google-Bewertung",
          url: "https://g.page/review/example",
          text: "Wir freuen uns riesig über deine tolle 5-Sterne-Bewertung auf Google!",
        },
      },
      {
        id: 4,
        name: "freitext",
        class: "freitext",
        pos_x: 1020,
        pos_y: 360,
        data: {
          frage: "Schade! Was können wir noch verbessern?",
          placeholder: "Teile uns bitte kurz mit, was nicht optimal war...",
        },
      },
      {
        id: 5,
        name: "save",
        class: "save",
        pos_x: 1520,
        pos_y: 360,
        data: {
          titel: "Danke für dein ehrliches Feedback!",
          text: "Wir nehmen deine Anregungen sehr ernst und arbeiten an einer Lösung.",
          autoreload: "false",
          autoReload: "false",
        },
      },
    ],
    connections: [
      [1, 2, "output_1", "input_1"],
      [2, 3, "output_1", "input_1"],
      [2, 4, "output_2", "input_1"],
      [4, 5, "output_1", "input_1"],
    ],
  },

  "smart-vip-funnel": {
    style: {
      primaryColor: "#4f46e5",
      secondaryColor: "#7c3aed",
      btnTextColor: "#ffffff",
      bgColor: "#0f172a",
      cardBgColor: "#1e293b",
      textColor: "#f8fafc",
      answerBgColor: "#262e3d",
      answerTextColor: "#f8fafc",
      answerBorderColor: "#334155",
      inputBgColor: "#262e3d",
      inputTextColor: "#f8fafc",
      inputBorderColor: "#334155",
      borderRadius: "16px",
      kioskTimeout: 0,
    },
    nodes: [
      {
        id: 1,
        name: "info",
        class: "info",
        pos_x: 60,
        pos_y: 220,
        data: {
          text: "Willkommen zu deinem Potenzial-Check! In 60 Sekunden finden wir das perfekte Angebot für dich.",
        },
      },
      {
        id: 2,
        name: "skala",
        class: "skala",
        pos_x: 520,
        pos_y: 220,
        data: {
          frage: "Wie wichtig ist dir eine schnelle Umsetzung in den nächsten 30 Tagen?",
          type: "star",
          skalaTyp: "star",
          count: "5",
        },
      },
      {
        id: 3,
        name: "weiche",
        class: "weiche",
        pos_x: 980,
        pos_y: 220,
        data: {
          operator: "gte",
          value: "4",
        },
      },
      // VIP Pfad (≥ 4 Sterne)
      {
        id: 4,
        name: "slider",
        class: "slider",
        pos_x: 1460,
        pos_y: 80,
        data: {
          frage: "Welches monatliche Investitions-Budget planst du ein?",
          min: "500",
          max: "10000",
          step: "250",
          default: "2500",
          unit: "€",
          prefix: "",
        },
      },
      {
        id: 5,
        name: "kontakt",
        class: "kontakt",
        pos_x: 1940,
        pos_y: 80,
        data: {
          header: "VIP-Erstberatung sichern",
          description: "Wir reservieren einen persönlichen Termin mit unserem Senior Consultant.",
          mail: "1",
          phone: "1",
          button: "Kostenlose VIP-Beratung sichern",
        },
      },
      {
        id: 6,
        name: "save",
        class: "save",
        pos_x: 2420,
        pos_y: 80,
        data: {
          titel: "VIP-Anfrage erfolgreich übermittelt! 🚀",
          text: "Vielen Dank! Unser Team meldet sich innerhalb von 24 Stunden persönlich bei dir.",
          autoreload: "true",
          autoReload: "true",
        },
      },
      // Standard / Orientierungs Pfad (< 4 Sterne)
      {
        id: 7,
        name: "mehrfach",
        class: "mehrfach",
        pos_x: 1460,
        pos_y: 380,
        data: {
          frage: "Welche Themen interessieren dich am meisten?",
          answer1: "Kostenlose Fallstudien & Praxisbeispiele",
          answer2: "Checklisten & Leitfäden",
          answer3: "Online-Demo & Produkttour",
          answer4: "Preise & Tarife im Überblick",
        },
      },
      {
        id: 8,
        name: "kontakt",
        class: "kontakt",
        pos_x: 1940,
        pos_y: 380,
        data: {
          header: "Kostenloses Info-Paket",
          description: "Wohin dürfen wir deine Unterlagen senden?",
          mail: "1",
          phone: "0",
          button: "Jetzt Info-Paket erhalten",
        },
      },
      {
        id: 9,
        name: "save",
        class: "save",
        pos_x: 2420,
        pos_y: 380,
        data: {
          titel: "Info-Paket ist auf dem Weg! 📬",
          text: "Wir haben dir die Unterlagen per E-Mail gesendet. Viel Erfolg beim Durcharbeiten!",
          autoreload: "true",
          autoReload: "true",
        },
      },
    ],
    connections: [
      [1, 2, "output_1", "input_1"],
      [2, 3, "output_1", "input_1"],
      [3, 4, "output_1", "input_1"], // JA: ≥4 Sterne -> VIP Slider -> VIP Kontakt -> VIP Save
      [4, 5, "output_1", "input_1"],
      [5, 6, "output_1", "input_1"],
      [3, 7, "output_2", "input_1"], // NEIN: <4 Sterne -> Themen Mehrfachauswahl -> Standard Kontakt -> Standard Save
      [7, 8, "output_1", "input_1"],
      [8, 9, "output_1", "input_1"],
    ],
  },
};
